import { SyntheticEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";
import Tab from "@mui/material/Tab";

import SegmentedToggle, {
    TAB_SIZES
} from "components/DesignComponents/SegmentedToggle";
import { useMediaQueries } from "shared/hooks/useMediaQueries";
import { body1Bold } from "shared/styles/typography";

import { TABS } from "./constants";
import History from "./History";
import Overview from "./Overview";

const Configuration = () => {
    const { t } = useTranslation();
    const { toMd } = useMediaQueries();

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (_: SyntheticEvent, newValue: number) =>
        setTabValue(newValue);

    return (
        <>
            <div
                css={css({
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "16px",

                    "@media(max-width: 839px)": {
                        display: "block"
                    }
                })}
            >
                <h4
                    css={[
                        body1Bold,
                        {
                            "@media(max-width: 839px)": {
                                marginBottom: "16px"
                            }
                        }
                    ]}
                >
                    {t(
                        "Table details##device details##configuration##configuration details"
                    )}
                </h4>

                <SegmentedToggle
                    fullWidth={toMd}
                    value={tabValue}
                    size={TAB_SIZES.Small}
                    onChange={handleTabChange}
                >
                    {TABS.map(tab => (
                        <Tab
                            key={tab}
                            label={t(
                                `Table details##device details##configuration##${tab}`
                            )}
                        />
                    ))}
                </SegmentedToggle>
            </div>

            {tabValue === 0 && <Overview />}
            {tabValue === 1 && <History />}
        </>
    );
};

export default Configuration;
